// extracted by mini-css-extract-plugin
export default {"main":"AppLayout_main__VJfxQ","navWrapper":"AppLayout_navWrapper__fMc1c","outlet":"AppLayout_outlet__DB0zR"};